import { extendTheme } from '@chakra-ui/react';
import { transparentize } from '@chakra-ui/theme-tools';
import { foundations } from './foundations';
import * as Components from './components';
import { getModeColors } from './foundations/colors';

// Note: For guide on customising theme, see this document:
// https://chakra-ui.com/docs/styled-system/theming/customize-theme

export const overrides = {
  ...foundations,
  layerStyles: {
    h1: {
      fontWeight: 300,
      fontSize: '8xl',
      lineHeight: '92px',
      letterSpacing: '-1.5px',
    },
    h2: {
      fontWeight: 300,
      fontSize: '6xl',
      lineHeight: '72px',
      letterSpacing: '-0.5px',
    },
    h3: {
      fontWeight: 400,
      fontSize: '5xl',
      lineHeight: '60px',
    },
    h4: {
      fontWeight: 600,
      fontSize: '4xl',
      lineHeight: '44px',
    },
    h5: {
      fontWeight: 400,
      fontSize: '2xl',
      lineHeight: '24px',
    },
    h6: {
      fontWeight: 500,
      fontSize: 'xl',
      lineHeight: '24px',
      letterSpacing: '0.15px',
    },
    subtitle1: {
      fontWeight: 400,
      fontSize: 'md',
      lineHeight: '24px',
      letterSpacing: '0.15px',
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: 'md',
      lineHeight: '19px',
      letterSpacing: '0.0015em',
    },
    base: {
      fontWeight: 400,
      fontSize: 'sm',
      lineHeight: '17px',
      letterSpacing: '0.5px',
    },
    base2: {
      fontWeight: 400,
      fontSize: 'sm',
      lineHeight: '24px',
      letterSpacing: '0.25px',
    },
    base3: {
      fontSize: 'md',
      lineHeight: '22px',
    },
    button: {
      fontWeight: 600,
      fontSize: 'sm',
      lineHeight: '16px',
      letterSpacing: '1.25px',
    },
    caption: {
      fontWeight: 400,
      fontSize: 'sm',
      lineHeight: '17px',
      letterSpacing: '0.4px',
    },
    overline: {
      fontWeight: 500,
      fontSize: 'xs',
      lineHeight: '17px',
      letterSpacing: '1.5px',
    },
    error: {
      fontWeight: 400,
      fontSize: 'xs',
      letterSpacing: '0.5px',
      color: 'red.500',
      lineHeight: '15px',
    },
  },
  components: {
    ...Components,
  },
  styles: {
    global: () => ({
      'div:hover::-webkit-scrollbar-thumb': {
        bg: transparentize('M.60', 0.18),
      },
      'div:hover::-webkit-scrollbar-thumb:hover': {
        bg: transparentize('M.60', 0.54),
      },
      'div:hover::-webkit-scrollbar-thumb:focus': {
        bg: transparentize('M.60', 0.72),
      },
      body: {
        letterSpacing: 0,
        color: 'textBase',
        bg: 'M.10',
        height: 'var(--chakra-vh)',
        overflow: 'hidden',
      },
      '*, *::before, &::after': {
        borderColor: 'borderBase',
        wordWrap: 'normal',
      },
    }),
  },
  config: {
    useSystemColorMode: true,
    initialColorMode: 'system',
  },
};

export const lightTheme = extendTheme(overrides, {
  colors: getModeColors('light'),
});

export const darkTheme = extendTheme(overrides, {
  colors: getModeColors('dark'),
});
